import { useEffect, useState } from "react";

const artistImages = [
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide1.webp", caption: "Kenz at Afro Sounds." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide2.webp", caption: "Osas at Afrostalgia." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide3.webp", caption: "Efosa at The AfroCollective Experience." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide4.webp", caption: "Gwamz at Afrostalgia 2." },
  { src: "https://d1g9iww9o5ioh1.cloudfront.net/home_page/homedaslide5.webp", caption: "Gwamz at The AfroCollective Experience." },
];

const DesktopCarousel = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, [index]);

  const prevSlide = () => {
    setIndex(
      (prevIndex) => (prevIndex - 1 + artistImages.length) % artistImages.length
    );
  };

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % artistImages.length);
  };

  return (
    <div className="carousel-wrapper">
      <button className="arrow left-arrow" onClick={prevSlide}>
        ◀
      </button>
      <div className="carousel-container">
        <div className="home-artists-cards-container">
          {artistImages.map((image, i) => {
            let position;
            if (i === index) position = "center"; // Focus image
            else if (i === (index + 1) % artistImages.length)
              position = "right"; // Next image
            else if (
              i ===
              (index - 1 + artistImages.length) % artistImages.length
            )
              position = "left"; // Previous image
            else position = "hidden"; // Other images

            return (
              <div key={i} className={`artist-card ${position}`}>
                <img src={image.src} alt={`Artist ${i + 1}`} />
                <span className="artist-img-caption">{image.caption}</span>
              </div>
            );
          })}
        </div>
      </div>
      <button className="arrow right-arrow" onClick={nextSlide}>
        ▶
      </button>
    </div>
  );
};

export default DesktopCarousel;
